var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("basic-container", { attrs: { block: _vm.payType === "qr" } }, [
    _vm.payType === "qr"
      ? _c(
          "div",
          {
            staticClass: "u-flex-col u-col-center u-font-weight-bold u-font-sm",
            staticStyle: { "margin-top": "30px" },
          },
          [
            _vm._v("\n\t\t使用手机扫描二维码进行支付操作\n\t\t"),
            _c("qrcode", {
              staticClass: "u-m-t-20",
              attrs: { options: _vm.options, value: _vm.payUrl },
            }),
          ],
          1
        )
      : _c(
          "div",
          [
            _c(
              "el-row",
              { attrs: { gutter: 20 } },
              [
                _c(
                  "el-col",
                  { attrs: { span: 20 } },
                  [
                    _c("el-input", {
                      attrs: { disabled: true },
                      model: {
                        value: _vm.payUrl,
                        callback: function ($$v) {
                          _vm.payUrl = $$v
                        },
                        expression: "payUrl",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          icon: "el-icon-document-copy",
                          type: "primary",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleCopy2Clipboard(_vm.payUrl)
                          },
                        },
                      },
                      [_vm._v("\n\t\t\t\t\t复制支付链接\n\t\t\t\t")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-row",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
              },
              [
                _c("el-col", { attrs: { span: 24 } }, [
                  _c("iframe", {
                    staticClass: "payContainer",
                    attrs: {
                      id: "payWnd",
                      src: _vm.payUrl,
                      frameborder: "0",
                      scrolling: "auto",
                    },
                  }),
                ]),
              ],
              1
            ),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }